import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useEzioAPI } from '@ezio/services'
import { BaseError, downloadFile } from '@ezio/utils'
import { Wallet } from '@ezio/features/bank/types'
// import { useEzioWs } from '@ezio/services'
import { Operations } from '@ezio/features/agencies/types'
import { localStores } from '@ezio/features'
import { ScaOperation } from 'sca/types'

export const useBankStore = defineStore('bank', () => {
    const { api } = useEzioAPI()
    // const { ws } = useEzioWs()

    const wallet = ref<Wallet>(null)
    const operations = ref<Operations>(null)
    const pendingPayins = ref<any[]>([])

    const init = () => {
        // ws.on('balance:update', (payload) => {
        //     console.log('balance update', payload)
        //     // fetch(payload.agency_id)
        // })
    }

    const fetch = async (agencyId?: string) => {
        if (!agencyId) {
            agencyId = localStores.currentStore?.agencyId
        }
        if (!agencyId) return
        try {
            const response = await api.get('agencies/' + agencyId + '/wallet')
            wallet.value = response.data
            return wallet.value
        } catch (error) {
            throw new BaseError({
                title: 'Oups !',
                message: error.message
            })
        }
    }

    const fetchOperations = async (cursor: string = null) => {
        const agencyId = localStores.currentStore?.agencyId
        if (!agencyId) return
        const operationsData = await api.get('agencies/' + agencyId + '/wallet/operations', { cursor })
        operations.value = operationsData.data
    }
    const fetchPendingPayins = async (cursor: string = null) => {
        const agencyId = localStores.currentStore?.agencyId
        if (!agencyId) return
        const response = await api.get('agencies/' + agencyId + '/wallet/pending_payins')
        pendingPayins.value = response.data.reverse()
    }

    const fetchAccountDetails = async (agencyId: string) => {
        const report = await api.get('agencies/' + agencyId + '/wallet/account_details')
        return report.data
    }
    const fetchStatement = async (agencyId: string, month: string, year: string, file_type = 'computed') => {
        const report = await api.get('agencies/' + agencyId + '/wallet/statements', {
            month,
            year,
            file_type
        })
        return report.data
    }

    const fetchReportsCollection = async (agencyId: string) => {
        const reports = await api.get('agencies/' + agencyId + '/wallet/operations/reports', { pagination: false })
        return reports.data
    }

    const fetchReport = async (agencyId: string, id: string) => {
        const report = await api.get('agencies/' + agencyId + '/wallet/operations/reports/' + id)
        return report.data
    }

    const handleValidatedScaOperation = async (operation: ScaOperation) => {
        if (operation.action === 'statement') {
            const response = await fetchStatement(operation.payload.afterValidation.agencyId, operation.payload.afterValidation.month, operation.payload.afterValidation.year)
            downloadFile(response.link, 'releve_compte_' + operation.payload.afterValidation.year + '-' + operation.payload.afterValidation.month + '.pdf')
        }
        if (operation.action === 'account_details') {
            const response = await fetchAccountDetails(operation.payload.afterValidation.agencyId)
            downloadFile(response.link, 'RIB_compte_ezio.pdf')
        }
    }

    const reset = async () => {
        wallet.value = null
    }

    return {
        wallet,
        operations,
        pendingPayins,
        init,
        fetch,
        fetchOperations,
        fetchPendingPayins,
        fetchAccountDetails,
        fetchStatement,
        fetchReportsCollection,
        fetchReport,
        handleValidatedScaOperation,
        reset
    }
})
